export default class ProductGroup {
    id: string;
    name: string;
    picture?: string;
    pLevel: ProductGroupLevel;
    productCount?: number;
    isChecked?: boolean;
    productCountExists?: boolean;
}

export enum ProductGroupLevel {
    Company = 0,
    Car = 1,
    Section = 2
}

export const persianNames = {
    [ProductGroupLevel.Company]: 'برند',
    [ProductGroupLevel.Car]: 'خودرو',
    [ProductGroupLevel.Section]: 'یخش',
}

export const productGroupNames = {
    [ProductGroupLevel.Company]: 'Company',
    [ProductGroupLevel.Car]: 'Car',
    [ProductGroupLevel.Section]: 'Section',
}